import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AdminLayout from "./Drawer";
import { formatDate, formatDateTime } from "../comman";
import "./userList.css";

const UserList = () => {
  const [events, setEvents] = useState([]);
  const [list, setList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0); // Store total records for pagination
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchEvents();
  }, []);

  // State to hold the events and users data
  const [usersData, setUsersData] = useState([]); // To store merged user data

  const fetchEvents = async () => {
    try {
      const response = await fetch("/api/get/events", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.status === "success") {
        setList(data.data); // Set events data
        // Once events are fetched, fetch users by eventId
        fetchUsersByEventIds(data.data);
      } else {
        console.error("Error in response data:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };

  const fetchUsersByEventIds = async (events) => {
    try {
      // Create an array to store all users data
      let allUsers = [];

      // Loop through each event and fetch the users for each eventId
      for (const event of events) {
        const response = await fetch(`/api/get/users?eventId=${event._id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.status === "success") {
          // Push the users of the current event into the allUsers array
          allUsers = [...allUsers, ...data.data]; // Merge user data
        } else {
          console.error("Error in response data:", data);
        }
      }

      // Set the final merged users data
      setUsersData(allUsers);
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };
  // useEffect(() => {
  //   fetchEvents();
  //   fetchUsers();
  // }, []);

  // const fetchEvents = async () => {
  //   try {
  //     const response = await fetch("/api/get/events", {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     //    console.log(data);

  //     if (data.status === "success") {
  //       setList(data.data);
  //     } else {
  //       console.error("Error in response data:", data);
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error.message);
  //   }
  // };
  // const fetchUsers = async () => {
  //   try {
  //     const response = await fetch("/api/get/users", {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //   //   console.log(data);

  //     if (data.status === "success") {
  //       setEvents(data.data);
  //     } else {
  //       console.error("Error in response data:", data);
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error.message);
  //   }
  // };

  // console.log(schemes)
  // const fetchUsers = async (page = 1, limit = 100) => {
  //   console.log("hello");
  //   console.log(page, limit);

  //   try {
  //     const response = await fetch(`/api/get/users?page=${page}&limit=${limit}`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     if (data.status === "success") {
  //       setEvents(data.data);
  //       setTotalRecords(data.totalRecords); // Store total records for pagination
  //       setCurrentPage(data.currentPage); // Store the current page
  //     } else {
  //       console.error("Error in response data:", data);
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error.message);
  //   }
  // };

  const columns = [
    { field: "id", headerName: "Sr.No.", minWidth: 40 },

    // PPP Grouping (Total, Pending, Approved, Rejected)
    {
      field: "name",
      headerName: "User Name",
      minWidth: 150,
      flex: 1,
      cellClassName: "total-column",
    },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 0.7,
      cellClassName: "pending-column",
    },
    {
      field: "gate",
      headerName: "Gate Number",
      minWidth: 150,
      flex: 0.7,
      cellClassName: "pending-column",
    },
    // { field: "code", headerName: "Code", minWidth: 150, flex: 1, cellClassName: 'approved-column' },
    {
      field: "pincode",
      headerName: "Pincode",
      minWidth: 100,
      flex: 0.5,
      cellClassName: "rejected-column",
    },
    {
      field: "eventId",
      headerName: "Event ID",
      minWidth: 100,
      flex: 0.5,
      cellClassName: "rejected-column",
    },
    {
      field: "attendance",
      headerName: "Attendance",
      minWidth: 100,
      flex: 0.5,
      valueGetter: (params) => (params === "Present" ? "Present" : "Absent"), // Set the display value
      cellClassName: (params) =>
        params?.row?.attendance === "Present"
          ? "attendance-present"
          : "attendance-absent", // Conditional class name
    },
    // DPP Grouping (Total, Pending, Approved, Rejected)
    {
      field: "address",
      headerName: "Address",
      minWidth: 150,
      flex: 1,
      cellClassName: "total-column",
    },
    {
      field: "event",
      headerName: "Event Name",
      minWidth: 150,
      flex: 1,
      cellClassName: "approved-column",
    },
    {
      field: "creation",
      headerName: "Creation Date",
      minWidth: 150,
      flex: 1,
      cellClassName: "approved-column",
    },
  ];
  // console.log(usersData);

  const handleStatus = (value) => {
    const event = list && list?.filter((item) => item._id === value)[0];
    return event?.eventName;
  };

  const handleAttendance = (value) => {
    return value === true ? "Present" : "Absent";
  };
  const rows =
    usersData &&
    usersData?.map((item, index) => ({
      id: index + 1,
      name: item?.firstName,
      mobileNumber: item?.mobileNumber,
      pincode: item?.pincode,
      address: item.address,
      limit: item.eventLimit,
      event: handleStatus(item.eventId),
      creation: item?.createdAt && formatDateTime(item.createdAt),
      attendance: item?.attend && handleAttendance(item?.attend),
      eventId: item.eventId,
      gate: item.gate,
    }));

  return (
    <AdminLayout>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        autoHeight
        slots={{
          toolbar: GridToolbar,
          NoRowsOverlay: <>No data found</>,
        }}
        classes={{
          root: "table-background",
          // columnHeaders: 'header-background'
        }}
      />
      {/* <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        rowCount={totalRecords} // Total number of records from the backend
        paginationMode="server" // Use server-side pagination
        page={currentPage - 1} // Convert 1-based currentPage to 0-based for DataGrid
        onPaginationModelChange={(params) => {
          // Extract the new page from the params object
          const newPage = params.page;
          console.log("New Page:", newPage); // Debugging log
          fetchUsers(newPage + 1); // Convert 0-based page back to 1-based for fetch
        }}
        autoHeight
        slots={{
          toolbar: GridToolbar,
          NoRowsOverlay: <>No data found</>,
        }}
        classes={{
          root: "table-background",
        }}
      /> */}
    </AdminLayout>
  );
};

export default UserList;
